<style lang="css">
.invalid-feedback {
    display: none;
    width: 100%;
    margin-top: .25rem;
    font-size: 65%;
    color: #dc3545
}
</style>

<template>
<div>
    <form class="col" @submit.prevent="collectPin" autocomplete="off">
        <div class="selectbank adselect">
            <div class="row">
                <div class="row">
                    <div class="input-field cardnumb">
                        <span class="cdnumber" for="card_cc">Card Number</span>
                        <img src="/mtn/assets/card.svg" alt="" class="ccv-icon b">
                        <TheMask :mask="['#### #### #### #### ###']" v-model="card_cc" id="card_cc" ref="card_cc" class="validate carddet" placeholder="0000 0000 0000 0000 000" title="Enter your card number" data-exception="cc" data-valid-example="5063 5232 3523 2533 234" required autofocus autocomplete="off" />
                        <span class="invalid-feedback" :style="(errors.card_cc) ? 'display : inline' : ''">Invalid card pan</span>
                    </div>
                </div>

                <div class="row add-new-card">
                    <div class="input-field col s4 col-expiry">
                        <span class="expiry" for="first_name">Date</span>
                        <img src="/mtn/assets/date.svg" alt="" class="ccv-icon">
                        <input placeholder="MM" v-model="card_exp_month" ref="card_exp_month" type="number" pattern="(?:0[1-9]|1[0-2])/[0-9]{2}" onKeyPress="if(this.value.length==2) return false;" class="validate carddet" autocomplete="off" />
                        <small class="invalid-feedback" :style="(errors.card_exp_month) ? 'display : inline' : ''">Invalid exp month</small>
                    </div>

                    <div class="input-field col s4 col-expiry">
                        <span class="expiry" for="first_name">Year</span>
                        <img src="/mtn/assets/date.svg" alt="" class="ccv-icon">
                        <input placeholder="YY" v-model="card_exp_year" ref="card_exp_year" type="number" pattern="(?:0[1-9]|1[0-2])/[0-9]{2}" onKeyPress="if(this.value.length==2) return false;" class="validate carddet" autocomplete="off" />
                        <span class="invalid-feedback" :style="(errors.card_exp_year) ? 'display : inline' : ''">Invalid exp. year</span>
                    </div>
                    <div class="input-field col s4 col-expiry ccv">
                        <span class="expiry" for="first_name">CCV</span>
                        <img src="/mtn/assets/lock.svg" alt="" class="ccv-icon">
                        <input placeholder="XXX" v-model="card_cvv" ref="card_cvv" type="number" pattern="(?:0[1-9]|1[0-2])/[0-9]{2}" onKeyPress="if(this.value.length==3) return false;" class="validate carddet" autocomplete="off" />
                        <span class="invalid-feedback" :style="(errors.card_cvv) ? 'display : inline' : ''">Invalid card CVV</span>
                    </div>

                </div>

            </div>
        </div>

        <button type="submit " class="viabutton submit" style="margin-top: 20px;">Proceed</button>
    </form>

</div>
</template>

<script>
import {
    TheMask
} from 'vue-the-mask'
import {
    EventBus
} from '../includes/bus.js'; // Masterpass, verve, visa

export default {
    props: {

    },
    components: {
        TheMask,
    },
    watch: {
        isVerve(val) {
            this.isVerve = val;
        },
        card_cc(val) {

            if (['0', '1', '2', '6', '7', '8', '9'].includes(val.substring(0, 1))) {
                this.errors.card_cc = true;
            } else {
                this.errors.card_cc = false;
                setTimeout(() => {
                    this.isVerve = false;
                    if (val.length >= 16) {
                        this.setCardType(val)
                        this.$refs.card_exp_month.focus();
                    }
                }, 200);
            }
        },
        card_exp_month(val) {
            if (this.$refs.card_exp_month && this.$refs.card_exp_month.focus()) {
                this.$refs.card_exp_month.$el.className += "appColor";
            }

            if (this.$refs.card_cvv && val.length == 2) {
                this.$refs.card_exp_year.focus();
            }
        },
        card_exp_year(val) {
            if (this.$refs.card_exp_year && this.$refs.card_exp_year.focus()) {
                this.$refs.card_exp_year.$el.className += "appColor";
            }

            if (this.$refs.card_cvv && val.length == 2) {
                this.$refs.card_cvv.focus();
            }
        },
    },
    data() {
        return {
            card_cc: '',
            card_exp: '',
            card_exp_month: '',
            card_exp_year: '',
            card_cvv: '',
            isVerve: false,
            errors: {
                card_cc: false,
                card_exp: false,
                card_exp_month: false,
                card_exp_year: false,
                card_cvv: false,
            },
        }
    },
    methods: {
        pickCardToDelete(val) {
            this.$emit('pickCardToDelete', val);
        },
        handleAttemptCardRemoval(val) {
            this.$emit('handleAttemptCardRemoval', val);
        },
        gotoCardListing() {
            this.$emit('gotoCardListing');
        },
        triggerCardInput() {
            this.$emit('triggerCardInput');
        },
        triggerManageCard() {
            this.$emit('triggerManageCard');
        },
        setCardType(val) {
            this.isVerve = false;
            if (val.substring(0, 2) === '50')
                this.isVerve = true;
        },

        cardExpHasError() {
            var exMonth = this.card_exp_month,
                exYear = "20" + this.card_exp_year,
                today = new Date(),
                someday = new Date();
            someday.setFullYear(exYear, parseInt(exMonth), 1);

            if (this.card_exp_month.length !== 2 || someday < today || exMonth > 12) {
                this.errors.card_exp_year = this.errors.card_exp_month = true;
                return true;
            }

            this.errors.card_exp_year = this.errors.card_exp_month = false;

            this.card_exp = `${this.card_exp_month}${this.card_exp_year}`
            return false;
        },

        cardCcHasError() {
            if ((this.isVerve && this.card_cc.length > 16) || (!this.isVerve && this.card_cc.length >= 16)) {
                return false;
            } else {
                this.errors.card_cc = true;
                return true;
            }
        },

        cardCvvhasError() {
            return this.card_cvv.length < 3 ? true : false;
        },

        showValidationErrors() {
            this.errors.card_cvv = false;
            this.errors.card_cc = false;
            this.errors.card_exp_month = false;
            this.errors.card_exp_year = false;

            if (this.cardCvvhasError()) {
                this.errors.card_cvv = true;
            }

            if (this.cardCcHasError()) {
                this.errors.card_cc = true;
            }

            if (this.cardExpHasError()) {
                this.errors.card_exp_month = true;
            }

            return this.errors.card_exp_month || this.errors.card_exp_year || this.errors.card_cc || this.errors.card_cvv;
        },
        collectPin() {

            if (this.showValidationErrors())
                return;

            this.$store.dispatch('card_cc', this.card_cc.toString().replace(/ /g, ''));
            this.$store.dispatch('card_exp', this.card_exp);
            this.$store.dispatch('card_cvv', this.card_cvv);
            EventBus.$emit('changeComponent', 'Pin');

        },
    },
}
</script>
